import React from "react";

const team = [
  {
    name: "Luis Fernando López",
    role: "Líder de Maniobras en Altura",
    cert: "Certificación SST · Alturas",
    img: "/img/equipo/luis-fernando-lopez.jpg",
  },
  {
    name: "Carlos Romero",
    role: "Técnico en Pruebas y Medición",
    cert: "Pruebas TTR · Megger · Hipot",
    img: "/img/equipo/carlos-romero.jpg",
  },
  {
    name: "Oscar Velandia",
    role: "Auxiliar de Operaciones Eléctricas",
    cert: "Operación de equipos MT/BT",
    img: "/img/equipo/oscar-velandia.jpg",
  },
  {
    name: "Jacobo Fernández",
    role: "Técnico Equipo de Alturas",
    cert: "Trabajo seguro en alturas",
    img: "/img/equipo/jacobo-fernandez.jpg",
  },
];

export default function Team() {
  return (
    <section
      id="equipo"
      data-testid="team-section"
      className="relative py-24 lg:py-32 bg-[#12141a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-8 mb-16 items-end">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#ff6b00]" />
              <span>Equipo técnico</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
              Manos certificadas en cada bobina.
            </h2>
          </div>
          <p className="text-[#a0aabf] leading-relaxed lg:pl-12">
            Nuestro equipo combina experiencia de campo, formación técnica y un
            compromiso absoluto con la seguridad. Cada intervención está
            respaldada por personal con certificaciones vigentes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {team.map((t) => (
            <article
              key={t.name}
              data-testid={`team-member-${t.name.toLowerCase().split(" ").join("-")}`}
              className="group bg-[#0a0a0a] border border-white/5 overflow-hidden hover:border-[#ff6b00]/40 transition-colors"
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#12141a]">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>
              <div className="p-5">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#ff6b00] mb-2">
                  Técnico certificado
                </div>
                <h3 className="font-display text-lg font-semibold leading-tight">
                  {t.name}
                </h3>
                <p className="text-sm text-[#a0aabf] mt-1">{t.role}</p>
                <p className="text-xs text-[#a0aabf]/70 mt-3 pt-3 border-t border-white/5">
                  {t.cert}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
